package com.islamicmedia.site.pages.isitsafe

import androidx.compose.runtime.Composable
import com.islamicmedia.site.components.PublicReviewPage
import com.varabyte.kobweb.core.Page

/** Public SEO review — "/isitsafe/moana-2". Pulls the REAL cached analysis (baked in StaticReviews). */
@Page("/isitsafe/moana-2")
@Composable
fun Moana2ReviewPage() {
    PublicReviewPage(
        slug = "moana-2",
        blurb = "Is Moana 2 OK for Muslim kids? Fitrah Filter checks movies, shows, games, and books against Islamic values. Here's the full breakdown for parents.",
    )
}
